import { css } from '@emotion/react'
import { size } from '@twistopayments/design-system/styles'

export const formError = css`
  margin-top: -12px;
`

export const inputs = css`
  position: relative;
  display: flex;
  flex-direction: column;
  gap: ${size[16]};
`
